import {useCallback, useState} from "react";
import api from "../../../../api/quiz";

export default function useConstructor() {
  const [isCreatingQuestion, setIsCreatingQuestion] = useState(false);
  const [isUpdatingQuestion, setIsUpdatingQuestion] = useState(false);
  const [isDeletingQuestion, setIsDeletingQuestion] = useState(false);

  const createQuestion = useCallback((id,data) => {
    setIsCreatingQuestion(true);
    return api.createQuestion(id,data).then(() => {
      setIsCreatingQuestion(false);
    }, () => {
      setIsCreatingQuestion(false);
    });
  }, [setIsCreatingQuestion]);

  const updateQuestion = useCallback((id,data) => {
    setIsUpdatingQuestion(true);
    return api.updateQuestion(id,data).then(() => {
      setIsUpdatingQuestion(false);
    }, () => {
      setIsUpdatingQuestion(false);
    });
  }, [setIsUpdatingQuestion]);

  const deleteQuestion = useCallback((id) => {
    setIsDeletingQuestion(true);
    return api.deleteQuestion(id).then(() => {
        setIsDeletingQuestion(false);
      }, () => {
        setIsDeletingQuestion(false);
      });
  }, [setIsDeletingQuestion]);

  return {
    deleteQuestion,
    createQuestion,
    updateQuestion,
    isCreatingQuestion,
    isDeletingQuestion,
    isUpdatingQuestion
  };
}
